<template>
  <div>
    Carregando....
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'feed-token',
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions([
      'setFBToken',
    ]),
    getInstagramCode() {
      const { code } = this.$route.query;
      if (code) {
        this.setFBToken(code)
          .then(() => {
            this.$router.push({ name: 'admin-feed-list' });
          });
      }
    },
  },
  mounted() {
    this.getInstagramCode();
  },
};
</script>

<style lang="scss" scoped>
</style>
